import BingoCard from 'components/organisms/bingo-card/card';
import MasterModal from 'components/organisms/masterModal';

import s from './styles.module.scss';

interface IBingoCardModalProps {
  toggleShowBingoCardModal: () => any;
  showBingoCardModal: boolean;
  bingoNumbers: number[];
  openedNumbers: number[];
  cardNumber: number;
}

export default function BingoCardModal(props: IBingoCardModalProps) {
  const { showBingoCardModal, toggleShowBingoCardModal } = props;
  const { bingoNumbers, cardNumber, openedNumbers } = props;

  return (
    showBingoCardModal && (
      <MasterModal
        modalClassName={s.modalWrapper}
        bodyClassName={s.modalBody}
        toggle={toggleShowBingoCardModal}
        title={`Bingo card #${cardNumber}`}
        isOpen={showBingoCardModal}
        footer={false}
      >
        <BingoCard
          bingoNumbers={bingoNumbers}
          openedNumbers={openedNumbers}
          cardNumber={cardNumber}
        />
      </MasterModal>
    )
  );
}
